import { UploadFile } from 'antd';

export const groupFilesIntoBatches = ({
  files,
  maxBatchSize
}: {
  files: UploadFile[];
  maxBatchSize: number;
}): UploadFile[][] => {
  const batches: UploadFile[][] = [];
  let currentBatch: UploadFile[] = [];
  let currentSize = 0;

  for (const file of files) {
    if (currentSize + (file.size ?? 0) > maxBatchSize) {
      batches.push(currentBatch);
      currentBatch = [];
      currentSize = 0;
    }
    currentBatch.push(file);
    currentSize += file.size ?? 0;
  }

  if (currentBatch.length) {
    batches.push(currentBatch);
  }

  return batches;
};
